import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Slide,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import React, {useEffect, useRef, useState} from 'react';
import * as yup from 'yup';
import {Formik, FormikProps} from 'formik';
import Cube, {DifficultyType, GameType, JourneyPhase, LengthOfGame, NumberOfPlayers} from '../../../Domain/Models/Cube';
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";
import Loading from "../../UiComponents/Loading";
import AddTestGroupRequest from "../../../Domain/Requests/Cubes/AddTestGroupRequest";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  dialog: {
    alignItems: 'flex-start',
  },
  deleteFlex: {
    flex: 1,
  }
}));

export interface CubeModalProps
{
  open: boolean;
  onClose: () => void;
  cube: Cube;
}

export default function AddTestGroupModal(props: CubeModalProps)
{
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {open, onClose, cube} = props;
  const classes = useStyles();

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string>();

  const formRef = useRef<FormikProps<AddTestGroupRequest>>(null);

  const schema = yup.object().shape({
  });

  const handleSubmit = (value: AddTestGroupRequest) =>
  {
    setSubmitting(true);
    setSubmitError(undefined);

    cubeRepository.testGroup(value)
      .then(() => onClose())
      .catch((e: Error) =>
      {
        setSubmitting(false);
        setSubmitError(e.message);
      });
  }

  useEffect(() =>
  {
    if (open)
    {
      setSubmitError(undefined);
      setSubmitting(false);
    }
  }, [open]);

  return (
      <Dialog
          classes={{scrollPaper: classes.dialog}}
          open={open}
          onClose={onClose}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="md"
          disableEscapeKeyDown
          disableBackdropClick={submitting}
          TransitionComponent={Transition}
      >
        <DialogTitle>Add Test Group</DialogTitle>

        <Loading isLoading={submitting}>
          <DialogContent>
            <Formik<AddTestGroupRequest>
                initialValues={{
                  cubeId: cube.id,
                  difficulty: cube.difficultyTypes[0],
                }}
                onSubmit={(value) => handleSubmit(value)}
                validationSchema={schema}
                innerRef={formRef}
            >
              {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur
                }) => (
                  <>
                    <FormControl fullWidth margin="normal">
                      <InputLabel htmlFor="component-error">Cube</InputLabel>
                      <Input
                          readOnly={true}
                          value={cube.name}/>
                    </FormControl>
                    
                    <FormControl fullWidth margin="normal" error={touched.difficulty && errors.difficulty !== undefined}>
                      <InputLabel htmlFor="component-error">Difficulty</InputLabel>
                      <Select
                          name="difficulty"
                          value={values.difficulty}
                          onChange={handleChange}
                      >
                        {cube.difficultyTypes.map((value) => <MenuItem value={value}>{value}</MenuItem>)}
                      </Select>
                      <FormHelperText>{touched.difficulty && errors.difficulty}</FormHelperText>
                    </FormControl>
                  </>
              )}
            </Formik>

            {submitError != undefined && (
                <Typography component="h3" variant="subtitle1" color="error" gutterBottom>
                  {submitError}
                </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button
                onClick={onClose} color="primary"
            >
              Cancel
            </Button>
            <Button
                onClick={() => formRef.current?.handleSubmit()}
                color="primary"
            >
              Submit
            </Button>
          </DialogActions>

        </Loading>
      </Dialog>
  );
}